<template lang="pug">
    div(ref="editNoteTextLocal" class="pa-2" :style="`top:${top - 120}px;`" style="position:absolute; left:120px; background-color:#F4F4F4; width:calc(100% - 155px); z-index:1000; border-radius:4px; border:1px solid rgba(100,100,100,.2);")
        div(class="mb-1" style="width:100%; border:0px solid;")
            textarea(v-model="note" ref="textAreaElement" class="pa-1" rows="3" maxlength="160" style="height:46px;resize:none; width:100%; background-color:white; border:0px solid grey;")
        div(style="float:left; width:50%; height:31px; border:0px solid;")
            ColorPicker(@updateChart="updateChart" :showPicker="true" :selectedColor="`${insider.background}`.trim()" :insider="insider" ref="colorPicker")
        div(class="text-right" style="float:left; width:50%; height:31px; border:0px solid;")
            //span Max characters: {{ 160 - note.length }}
            span {{ 160 - note.length }}
            v-btn(@click="close()" elevation="0" small class="ml-2 mr-2 btn-secondary") {{ $t('Cancel') }}
            v-btn(@click="saveNote()" elevation="0" small class="btn-primary") {{ $t('Save') }}
</template>

<script>
import { mapMutations } from 'vuex';
import ColorPicker from './ColorPicker';
import ApiService from './../Services/ApiService';

export default {
    name: 'EditJournalNoteAndColor',
    props: {
        insider: Object,
        top: Number
    },
    components: {
        ColorPicker
    },
    data() {
        return {
            switchOnEvent: false,
            note: this.insider.note
        };
    },
    mounted() {
        window.addEventListener('mouseup', this.removeEditNoteText);
    },
    beforeDestroy() {
        console.log('beforeDestroy');
        window.removeEventListener('mouseup', this.removeEditNoteText);
    },
    methods: {
        ...mapMutations([
            'updateMapUserDiaryItem'
        ]),
        removeEditNoteText(e) {
            console.log('removeEditNoteText');

            if(this.$refs.editNoteTextLocal !== undefined) {
                const element = this.$refs.editNoteTextLocal;

                if(!element.contains(e.target)) {
                    console.log('outside');

                    this.$parent.showEditNote = false;
                }

                console.log(this.$parent.showEditNote);
            }
        },
        async saveNote() {
            const data = {
                diary_item_id: this.insider.diary_item_id,
                note: this.note
            };

            await ApiService.updateDiaryItem(data);

            this.updateMapUserDiaryItem(Object.assign({}, data, { key: 'note' }));

            this.$emit('updateChart');

            this.$parent.showEditNote = false;
        },
        close() {
            this.$parent.showEditNote = false;
        },
        updateChart() {
            this.$emit('updateChart');
        }
    }
}
</script>

<style scoped>
textarea:focus {
    outline: none !important;
}
</style>
